module.exports = __webpack_public_path__ + "static/5-edcb80fcf28358b06eb73da56c2a7900.png";